<script setup lang="ts">
  interface Props {
    width: number;
  }
  const props = withDefaults(defineProps<Props>(), {
    width: 28,
  });
  const padding = 14;
  const wrapperWidth = computed<string>(() => (props.width ? `${props.width}px` : "100%"));
</script>
<template>
  <div>
    <div class="container">
      <AtomsSvgIcon
        class="icon-button"
        :width="width - padding"
        img-path="assets/images/icon/pip.svg"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .container {
    width: v-bind(wrapperWidth);
    height: v-bind(wrapperWidth);
    position: relative;
    cursor: pointer;
    border-radius: 30px;
    background-color: rgba(54, 30, 255, 0.3) !important;
  }
  .icon-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
